import { createSelector } from 'reselect';

const selectTargets = state => state.queryBuilder.targets;

export const getTargetsIds = createSelector([selectTargets], targets => {
  return (targets && Object.keys(targets)) || [];
});

export const getTargets = createSelector([selectTargets], targets => {
  return Object.keys(targets).map(targetId => ({
    ...targets[targetId],
    target_id: targetId,
  }));
});

const selectOriginalTargets = state => state.queryBuilder.originalTargets;

export const getOriginalTargets = createSelector(
  [selectOriginalTargets],
  originalTargets => {
    if (!originalTargets || Object.keys(originalTargets).length === 0) {
      return [];
    }

    const result = Object.keys(originalTargets).map(targetId => ({
      ...originalTargets[targetId],
      target_id: targetId,
    }));

    return result;
  }
);
